import Typography from '@/components/UI/typography/Typography';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import styles from './CalendarDates.module.scss';
const CalenderDates = ({
  checkin,
  checkout,
  clearable = false,
  cleanCheckout = () => {},
  cleanCheckIn = () => {},
  rounded = false
}) => {
  const formatTime = time => {
    const timeDate = new Date(time * 1000);
    const [week, month, day] = timeDate.toLocaleDateString('fa-IR', {
      day: 'numeric',
      month: 'long',
      weekday: 'long'
    }).split(' ');
    return `${week} , ${month} ${day}`;
  };
  return <Box className={`${styles['date-box-styles']} ${rounded ? styles['rounded'] : ''}`} data-sentry-element="Box" data-sentry-component="CalenderDates" data-sentry-source-file="CalenderDates.tsx">
      <Box className={styles['date-title-checkin-wrapper']} data-sentry-element="Box" data-sentry-source-file="CalenderDates.tsx">
        <Box className={styles['date-title-checkin']} data-sentry-element="Box" data-sentry-source-file="CalenderDates.tsx">
          {checkin ? <Typography className={styles['date-title-filled']} color={'neutral_500'} variant="bodyS" component="p">
              تاریخ ورود
            </Typography> : <Typography className={styles['date-title-cleared']} color={'neutral_500'} variant="bodyM_Bold" component="p">
              تاریخ ورود
            </Typography>}
          <Typography color={'neutral_800'} component="p" variant="bodyS_Bold" data-sentry-element="Typography" data-sentry-source-file="CalenderDates.tsx">
            {!!checkin && formatTime(checkin)}
          </Typography>
        </Box>
        {checkin && clearable && <Box component="button" onClick={cleanCheckIn} className={styles['date-title-checkin-icon-wrapper']}>
            <Icon size="small" type={'secondary'} name={'close'}></Icon>
          </Box>}
      </Box>
      <Box className={styles['date-title-checkout-wrapper']} data-sentry-element="Box" data-sentry-source-file="CalenderDates.tsx">
        <Box className="date-title-checkout" data-sentry-element="Box" data-sentry-source-file="CalenderDates.tsx">
          {checkout ? <Typography className={styles['date-title-filled']} color={'neutral_500'} variant="bodyS" component="p">
              تاریخ خروج
            </Typography> : <Typography className={styles['date-title-cleared']} color={'neutral_500'} variant="bodyM_Bold" component="p">
              تاریخ خروج
            </Typography>}
          <Typography component="p" color={'neutral_800'} variant="bodyS_Bold" data-sentry-element="Typography" data-sentry-source-file="CalenderDates.tsx">
            {!!checkout && formatTime(checkout)}
          </Typography>
        </Box>
        {checkout && clearable && <Box component="button" onClick={cleanCheckout} className={styles['date-title-checkout-icon-wrapper']}>
            <Icon size="small" type={'secondary'} name={'close'}></Icon>
          </Box>}
      </Box>
    </Box>;
};
export default CalenderDates;